import myUtil from '../../util';
import wxLoader from '@dp/weixin-js-sdk-loader';

import shareModel from './components/share';

import ERRCODE from '../../../constant/errorCode';

/**
 * 为了保持状态码的基本一致，所以需要对于已有映射的状态码进行一个转换
 * @param {number} code 状态码
 */
function wxCodeChange(code) {
  return code;
}

export default (BaseAdapter) => {
  class WxAdapter extends BaseAdapter {
    constructor(sdk) {
      super(sdk);
      this.platform = 'weixin';
    }

    static canUse() {
      const env = myUtil.getEnv();
      return Promise.resolve(env === 'weixin');
    }

    static load() {
      // 因为没有 appkey ，所以暂时使用 @dp/wx-js-sdk-loader, 并且超时是写在各自的 Adapter 里面
      return Promise.race([
        new Promise((resolve, reject) => {
          wxLoader.use((wx) => {
            if (!wx) {
              return reject(new Error('Load wx sdk error'));
            }
            resolve(wx);
          });
        }),
        new Promise((resolve, reject) => {
          setTimeout(() => reject(new Error('Load wx sdk timeout')), 10000);
        })
      ]);
    }

    triggerShareModal(opts) {
      const hideHandle = shareModel(() => {
        opts.fail(ERRCODE.USER_CANCEL);
      });
      const { success } = opts;
      opts.success = (...args) => {
        hideHandle();
        success(...args);
      };
    }

    config() {
      return Promise.race([
        new Promise((resolve, reject) => {
          this.sdk.ready(resolve);
          this.sdk.error(reject);
        }),
        new Promise((resolve, reject) => {
          setTimeout(() => reject(new Error('Wx config Timeout!')), 5000);
        })
      ]);
    }

    argsPretreat(originArgs) {
      const args = Object.assign({}, originArgs);
      const { fail } = args;

      // 对通用参数进行转换
      args.cancel = (err) => {
        fail({
          errorCode: wxCodeChange(err.errCode),
          errorMsg: err.errMsg,
          ...err
        });
      };
      args.fail = (err) => {
        fail({
          errorCode: wxCodeChange(err.errCode),
          errorMsg: err.errMsg,
          ...err
        });
      };

      return args;
    }

    share(opts) {
      const { channel } = opts;
      const shareFunc = {
        WECHAT_FRIENDS (args) {
          // 因为微信 jssdk 1.4.0 的逻辑与 1.3.1 不一致，所以暂时不做处理
          // return sdk.onMenuShareAppMessage
          //     ? this._execSDK('onMenuShareAppMessage', args)
          //     : this._execSDK('updateAppMessageShareData', args);
          return this._execSDK('onMenuShareAppMessage', args);
        },
        QQ (args) {
          // return sdk.onMenuShareQQ
          //     ? this._execSDK('onMenuShareQQ', args)
          //     : this._execSDK('updateAppMessageShareData', args);
          return this._execSDK('onMenuShareQQ', args);
        },
        WECHAT_TIMELINE (args) {
          // return sdk.onMenuShareTimeline
          //     ? this._execSDK('onMenuShareTimeline', args)
          //     : this._execSDK('updateTimelineShareData', args);
          return this._execSDK('onMenuShareTimeline', args);
        },
        QZONE (args) {
          // return sdk.onMenuShareQZone
          //     ? this._execSDK('onMenuShareQZone', args)
          //     : this._execSDK('updateTimelineShareData', args);
          this._execSDK('onMenuShareQZone', args);
        }
      };

      // 参数校验和转换
      const { title, desc, image, url, fail, success } = opts;
      const { content = `【${title}】 ${desc}` } = opts;
      if (title === undefined || url === undefined) {
        return fail(ERRCODE.PARAMS_LACK);
      }
      Object.assign(opts, {
        link: url,
        imgUrl: image,
        content
      });

      // 封装微信 jssdk 的成功返回
      opts.success = (res) => {
        const { errMsg = '' } = res;
        const shareTo = {};
        if (errMsg.startsWith('sendAppMessage:ok')) {
          shareTo.WECHAT_FRIENDS = true;
        }
        if (errMsg.startsWith('shareTimeline:ok')) {
          shareTo.WECHAT_TIMELINE = true;
        }
        if (errMsg.startsWith('shareQQ:ok')) {
          shareTo.QQ = true;
        }
        if (errMsg.startsWith('shareQZone:ok')) {
          shareTo.QZONE = true;
        }
        res.shareTo = shareTo;
        success(res);
      };
      // 弹出引导层
      this.triggerShareModal && this.triggerShareModal(opts);
      // do
      if (channel === undefined) {
        // 全渠道设置
        for (let key in shareFunc) {
          shareFunc.hasOwnProperty(key) && shareFunc[key].call(this, opts);
        }
      } else {
        channel.forEach((v) => shareFunc[v] && shareFunc[v].call(this, opts));
      }
    }

    closeWebview() {
      this._execSDK('closeWindow');
    }
  }

  return WxAdapter;
};
